module.exports = __webpack_public_path__ + "img/MX.66983cb3.svg";